import {
  ITrackingPlugin,
  TTrackingEventOptions,
  TTrackingModalViewOptions,
  TTrackingPageViewOptions,
  TTrackingPluginInitConfiguration
} from "./plugin";

const NoOpTrackingPlugin = (): ITrackingPlugin => {
  return {
    init(config: TTrackingPluginInitConfiguration) {
      return;
    },
    setProperty(fieldValues: any) {
      return;
    },
    trackPageView(options: TTrackingPageViewOptions) {
      return;
    },
    trackModalView(options: TTrackingModalViewOptions) {
      return;
    },
    trackEvent(event: TTrackingEventOptions) {
      return;
    }
  };
};
export default NoOpTrackingPlugin;
